import { render, staticRenderFns } from "./ownerManageSettle.vue?vue&type=template&id=193db678&scoped=true"
import script from "./ownerManageSettle.vue?vue&type=script&lang=js"
export * from "./ownerManageSettle.vue?vue&type=script&lang=js"
import style0 from "./ownerManageSettle.vue?vue&type=style&index=0&id=193db678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193db678",
  null
  
)

export default component.exports